module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaDerecha-dd-1998e8fc.png";